<template>
	<el-dialog :visible.sync="visible" width="928px">
		<div class="pb-10" slot="title">达人跟进规则</div>
		<div class="flex-row">
			<div>
				<div
					class="ruleSet_tab cursor-pointer"
					:class="{ ruleSet_tab_active: item.value == many_partner }"
					v-for="(item, index) in followTypeList"
					:key="index"
					@click="many_partner = item.value"
				>
					<i :class="[item.value == many_partner ? `${item.activeIcon} mr-6` : `${item.icon} mr-6`]" />
					<span class="font-h4-medium">{{ item.label }}</span>
				</div>
			</div>
			<div class="flex-1 example_right ml-20">
				<div class="fz-12 color-gy-7 text-align-center mt-24">
					{{ exampleCom.tips }}
				</div>
				<div class="example_right_img">
					<img :src="exampleCom.img" />
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			example_map: {
				0: {
					tips: '单人跟进: 1个达人全程由1个达人运营跟进',
					img: require('@/assets/public/img-ruleSet-example1.png'),
				},
				1: {
					tips: '多人跟进: 1个达人可被多个达人运营同时跟进，系统会自动判断撞单',
					img: require('@/assets/public/img-ruleSet-example2.png'),
				},
			},
			visible: false,

			many_partner: 0,

			platformId: '',
		};
	},
	props: {
		followTypeList: {
			type: Array,
			default: () => [],
		},
	},
	methods: {
		show(many_partner, platformId) {
			this.many_partner = many_partner;
			this.platformId = platformId;
			this.visible = true;
		},
	},
	computed: {
		exampleCom() {
			return this.example_map[this.many_partner];
		},
	},
};
</script>

<style lang="less" scoped>
.ruleSet_tab {
	height: 64px;
	width: 276px;
	border: 1px solid @color-gy5;
	border-radius: 8px;
	display: flex;
	align-items: center;
	padding-left: 24px;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
	margin-bottom: 8px;
}
.ruleSet_tab_active {
	border: 1px solid @color-primary;
	color: @color-primary;
}
.example_right {
	background: rgba(112, 82, 255, 0.04);
	border-radius: 8px;
}
.example_right_img {
	width: 100%;
	box-sizing: border-box;
	img {
		width: 100%;
	}
}
</style>
